import React, {useEffect, useRef, useState} from 'react';
import {soekHund} from '../api';
import {useHistory, withRouter} from "react-router-dom";
import qs from "query-string";


//  custom search api hook
const useSearchDataApi = (query, antall) => {
    const [hunder, setHunder] = useState([]);
    const [antallTreff, setAntallTreff] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        let unmounted = false;
        const fetchData = () => {
            if (!unmounted) {
                setIsLoading(true);
                setError(null);
            }
            if (query !== '' && antall < 500) {
                soekHund(query.trim(), antall)
                    .then((queryResult) => {
                        if (!unmounted) {
                            setHunder(queryResult.hunder);

                            setAntallTreff(queryResult.antallTreff);
                        }
                    })
                    .catch((err)=> {
                        if (!unmounted) {
                            setError("Prøv igen");
                        }
                    });
            }
             else {
                 if (antall > 500) {
                     setError("Begrens søget");
                 }
                 setIsLoading(false);
                 setAntallTreff(null);
                 setHunder([]);
             }
        };
        fetchData();

        return () => {
            unmounted = true;
        }
    }, [query, antall]);

    return [error, isLoading, hunder, antallTreff];
}


const SearchForm = ({onSearchSubmit, autoFocus, onInputChange, inputValue, classnames, hideToolbarOnSearch}) => {

    const mainRef = useRef(null);

    useEffect(() => {
        if (autoFocus) {
            mainRef.current.focus();
        }
    });

    const onBlur = (e) => {
        if (hideToolbarOnSearch && (inputValue === null || inputValue === '')) {
            e.preventDefault();
            document.getElementById("tool-bar").classList.remove("hideTool");
        }
    };

    const toggleToolBar = (e) => {
        if (hideToolbarOnSearch) {
            e.preventDefault();
            if (e.target.value !== '') {
                document.getElementById("tool-bar").classList.add("hideTool")
            } else{
                document.getElementById("tool-bar").classList.remove("hideTool")
            }
        }
    };

    return (
        <form action=""
              className={classnames}
              onSubmit={onSearchSubmit}>

            <input className='search-field'
                   type="search"
                   name="search"
                   placeholder="Reg.nr eller Navn "
                   autoComplete='off'
                   value={inputValue}
                   onChange={e => {toggleToolBar(e); onInputChange(e); }}
                   onBlur={onBlur}
                   ref={mainRef}
            />
            <button className="search-button" type="submit">
                <svg width="16px" height="16px" viewBox="0 0 13 13">
                    <title>search</title>
                    <path d="m4.8495 7.8226c0.82666 0 1.5262-0.29146 2.0985-0.87438 0.57232-0.58292 0.86378-1.2877 0.87438-2.1144 0.010599-0.82666-0.28086-1.5262-0.87438-2.0985-0.59352-0.57232-1.293-0.86378-2.0985-0.87438-0.8055-0.010599-1.5103 0.28086-2.1144 0.87438-0.60414 0.59352-0.8956 1.293-0.87438 2.0985 0.021197 0.8055 0.31266 1.5103 0.87438 2.1144 0.56172 0.60414 1.2665 0.8956 2.1144 0.87438zm4.4695 0.2115 3.681 3.6819-1.259 1.284-3.6817-3.7 0.0019784-0.69479-0.090043-0.098846c-0.87973 0.76087-1.92 1.1413-3.1207 1.1413-1.3553 0-2.5025-0.46363-3.4417-1.3909s-1.4088-2.0686-1.4088-3.4239c0-1.3553 0.4696-2.4966 1.4088-3.4239 0.9392-0.92727 2.0864-1.3969 3.4417-1.4088 1.3553-0.011889 2.4906 0.45771 3.406 1.4088 0.9154 0.95107 1.379 2.0924 1.3909 3.4239 0 1.2126-0.38043 2.2588-1.1413 3.1385l0.098834 0.090049z"></path>
                </svg>
            </button>

        </form>
    )

}

const SearchContainer = (props) => {
    let history = useHistory();
    const hideToolbarOnSearch = props.hideToolbarOnSearch || false;
    const parsed = qs.parse(history.location.search);
    let autoFocus = false;
    if (parsed.focus === 'true') {
        autoFocus = true;
    }
    let query = "";
    if (parsed.query !== undefined) {
        query = parsed.query;
    }
    let antall = 20;
    if (parsed.antall !== undefined) {
        antall = parsed.antall;
    }


    const [error, isLoading, hunder, antallTreff] = useSearchDataApi(query, antall);

    const onSearchSubmit = (e) => {
        e.preventDefault();
    }


    //  on input change function
    const getClassnames = () => (
        (query || hunder !== null)
        ? 'search-form hooked'
        : 'search-form'
    )

    const queryInputChange = (e) => {
        let params = parsed;
        params.query = e.target.value;
        params.antall = 20;
        history.push(history.location.pathname + "?" + qs.stringify(params));
    };

    const loadMoreData = (antall) => {
        let params = parsed;
        params.querySearch = false;
        //params.side = side;
        params.antall = antall;
        history.push(history.location.pathname + "?" + qs.stringify(params));
    };


    return (
        <div className="search-container">
            <SearchForm
                classnames={getClassnames()}
                autoFocus={autoFocus}
                onSearchSubmit={onSearchSubmit}
                onInputChange={queryInputChange}
                inputValue={query}
                hideToolbarOnSearch={hideToolbarOnSearch}
            />
            { props.children({ errorText: error, isLoading: isLoading, hunder: hunder, antallTreff: antallTreff, sisteHunder: props.sisteHunder, loadMoreData: loadMoreData })}

        </div>
    )
}

export default withRouter(SearchContainer);
